import React from 'react'

import HeaderWidget from '../../../../../components/atoms/HeaderWidget'

const TimeToCompletion: React.FC = () => {
  return (
    <HeaderWidget
      title='Time To Completion'
      information='This metric measures the average time it takes to complete a task.'
    >
      -
    </HeaderWidget>
  )
}

export default TimeToCompletion
